module.exports = __webpack_public_path__ + "static/media/step_img_05.3e7135d9.png";